import {PwrCnt} from '../model/pwrcnt.model';
import {Injectable} from '@angular/core';
import { AngularFireDatabase, AngularFireList } from 'angularfire2/database';
import { Observable } from 'rxjs/Observable';
import * as firebase from 'firebase/app';
import { Panel } from 'app/model/panel.model';

@Injectable()
export class PanelsService {

  PANELS: Array<any> = [];
  efficiencyFactor = 0.8;

  items: Observable<any[]>;

  panelChoosen: Panel = undefined;

  constructor(public af: AngularFireDatabase) {
    this.items = af.list('/panele' ).valueChanges();

    const subscription = this.items.subscribe(
      value => this.addOrUpdate(value) // ,
      // error => this.anyErrors = true,
      // () => this.finished = true
    );
  }

  addOrUpdate(val: Array<any> ) {
    this.PANELS.splice(0);
    this.PANELS  = this.PANELS.concat(val);
  }


  isPanelSet(): boolean {
    return this.panelChoosen !== undefined;
  }
  resetPanel() {
    this.panelChoosen = undefined;
  }

  /**
   * Zwraca dane o liczbie i typie paneli do zapewnienia oczekiwanej mocy dla danej powierzchni dachu
   * @param roofArea dostępna powierzchnia dachu
   * @param requestedPower oczekiwana moc instalacji
   */
  getPanelsForPower_W(roofArea: number, I_gr: number, requestedPower: number): PwrCnt {
    let bestPwrCnt: PwrCnt;
    const rPwr = requestedPower / 1000;

    if (this.isPanelSet()) {
      return this._getPwrCntFor(rPwr, roofArea, this.panelChoosen, I_gr);
    }
    for (const panel of this.PANELS) {
      // for each panel find set of them matching the power
      const pc = this._getPwrCntFor(rPwr, roofArea,  panel, I_gr);
      if (!bestPwrCnt) {
        bestPwrCnt = pc;
        this.panelChoosen = panel;
      } else {
        if (bestPwrCnt.pwr < pc.pwr) {
          bestPwrCnt = pc;
          this.panelChoosen = panel;
        }
      }
    }
    return bestPwrCnt;
  }

  /**
   * Calc real power efficiency of theoretical power efficiency.
   * @param theoreticalPower theoretical power efficiency.
   */
  calcRealPower(theoreticalPower: number): number {
    return theoreticalPower * this.efficiencyFactor;
  }

  /**
   *
   * @param requestedPower oczekiwana moc instalacji [W]
   * @param panelPwr moc szczytowa panela [W]
   * @param roofArea powierzchnia dachu [m2]
   * @param l długość panela [mm]
   * @param w szerokość panela [mm]
   */
  _getPwrCntFor(requestedPower: number, roofArea: number, panel: Panel, I_gr: number): PwrCnt {
    const panelPwrIgr = panel.powerW * this.efficiencyFactor * (I_gr / 1000);
    const panelArea = panel.l / 1000 * panel.w / 1000; // [m2]
    const numOfPanelsArea = Math.floor(roofArea / panelArea);
    const numOfPanelsPwr = Math.floor(requestedPower / panelPwrIgr);
    const pwrCnt = new PwrCnt();
    pwrCnt.cnt = (numOfPanelsPwr < numOfPanelsArea ? numOfPanelsPwr : numOfPanelsArea);
    pwrCnt.pwr = pwrCnt.cnt * panelPwrIgr;
    pwrCnt.panel = panel;
    return pwrCnt;
  }

  // -------
  getPanelsForArea(roofArea: number) {
    let bestPwrCnt: PwrCnt;
    for (const panel of this.PANELS) {
      // for each panel find set of them matching the power
      const pc = this.getPwrCntForArea(panel.powerW, roofArea, panel.l, panel.w);
      if (!bestPwrCnt) {
        bestPwrCnt = pc;
        bestPwrCnt.panel = panel;
      } else {
        if (bestPwrCnt.pwr < pc.pwr) {
          bestPwrCnt = pc;
          bestPwrCnt.panel = panel;
        }
      }
    }
    return bestPwrCnt;
  }

  getPwrCntForArea(panelPwr: number, roofArea: number, l: number, w: number): PwrCnt {
    const panelArea = l / 1000 * w / 1000;
    const xArea =  Math.floor(roofArea / panelArea);
    const pc: PwrCnt = new PwrCnt();

    pc.cnt = xArea;
    pc.pwr = pc.cnt * panelPwr;

    return pc;
  }
}




// WEBPACK FOOTER //
// /Users/michaldudziak/Desktop/Projekty/Projekt-Sunroof/Sunroof/src/app/services/panels.service.ts